export default __webpack_public_path__ + "static/media/inc-tour-bg.da836f9a.jpg";